<template>
  <div
    :class="[
      DeliveryTypeCode == 'D'
        ? 'order-status-timeline-wrap'
        : 'order-status-timeline-wrap-dinein',
    ]"
  >
    <div class="dlvry-type">
      <i class="hkfi-hb-location fs-16 color-grey-light pr8"></i>
      <span class="text fs-14">
        {{ OrderTypeTitle }}
        <span class="bold text fs-14">{{ DeliveryAddressTitle }}</span></span
      >
      <div class="address ml20 fs-12 color-slaty three-dot">
        {{ DisplayDeliveryAddress || DisplayStoreAddress }}
      </div>
    </div>
    <div class="order-status-title medium fs-12">Order Status</div>
    <div class="order-status-slider" v-if="isOrderSuccesful">
      <ul class="progressbar">
        <li
          v-for="item in SliderData"
          :key="item?.id"
          :class="[
            item?.id < checkIndex()
              ? 'done'
              : item?.id == checkIndex()
              ? 'active'
              : 'inactive',
          ]"
        >
          <div
            :class="[
              item?.id < checkIndex()
                ? 'text-done fs-11'
                : item?.id == checkIndex()
                ? 'text-active bold fs-11'
                : 'text-inactive fs-11',
            ]"
          >
            {{ item?.text }}
          </div>
          <i class="hkfi-ok ml2" v-if="item?.id <= checkIndex()"></i>
        </li>
        <!-- <li class="done"><div>hello</div></li>
    <li class="done"><i class="hkfi-thank-you-tick"></i></li>
    <li class="active"></li>
    <li class="inactive"></li> -->
      </ul>
    </div>
    <div
      v-else
      class="d-flex align-items-center justify-content-center fs-20 bold"
    >
      <i class="hkfi-close mr4 highlightText pr8 fs-18"></i>Failed
    </div>
  </div>
</template>

<script>
import {
  OrderStatusTimelineConstantsForDelivery,
  OrderStatusTimelineConstantsForTakeAway,
  OrderStatusTimelineConstantsForDinein,
} from "../helpers/OrderStatusConstants";
import { OrderTypesTextForCurrentOrderFromCode } from "../helpers/orderTypesConstants";
import LocalStorageFunc from "../helpers/localStorageFunc";
export default {
  name: "OrderStatusTimeline",
  props: {
    activeIndex: { required: false, default: 1 },
    isOrderSuccesful: { required: false, default: true },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    checkIndex() {
      return this.activeIndex;
    },
  },
  computed: {
    OrderTypeTitle() {
      let deliveryTypeCode =
        this.$store.state.OrderTracking.trackOrder.orderSummary
          ?.deliveryOrderType?.deliveryTypeCode ||
        LocalStorageFunc.getOrderSummary()?.deliveryOrderType?.deliveryTypeCode;

      return OrderTypesTextForCurrentOrderFromCode[deliveryTypeCode];
    },
    DeliveryAddressTitle() {
      return this.$store.state.OrderTracking.trackOrder?.orderSummary
        ?.deliveryAddress?.customer_address_name;
    },
    DisplayDeliveryAddress() {
      if (
        this.$store.state.OrderTracking.trackOrder.orderSummary
          ?.deliveryOrderType?.deliveryTypeCode === "D" ||
        LocalStorageFunc.getOrderSummary()?.deliveryOrderType
          ?.deliveryTypeCode === "D"
      ) {
        return (
          this.$store.state.OrderTracking.trackOrder.orderSummary
            ?.deliveryAddress?.formatted_address ||
          LocalStorageFunc.getOrderSummary()?.deliveryAddress?.formatted_address
        );
      } else return "";
    },
    DisplayStoreAddress() {
      return (
        this.$store.state.OrderTracking.trackOrder.orderSummary?.store
          ?.addressLine ||
        LocalStorageFunc.getOrderSummary()?.store?.addressLine
      );
    },
    DeliveryTypeCode() {
      let deliveryTypeCode =
        this.$store.state.OrderTracking.trackOrder.orderSummary
          ?.deliveryOrderType?.deliveryTypeCode ||
        LocalStorageFunc.getOrderSummary()?.deliveryOrderType?.deliveryTypeCode;
      return deliveryTypeCode;
    },
    SliderData() {
      let deliveryTypeCode =
        this.$store.state.OrderTracking.trackOrder.orderSummary
          ?.deliveryOrderType?.deliveryTypeCode ||
        LocalStorageFunc.getOrderSummary()?.deliveryOrderType?.deliveryTypeCode;

      switch (deliveryTypeCode) {
        case "D":
          return OrderStatusTimelineConstantsForDelivery;
        case "P":
          return OrderStatusTimelineConstantsForTakeAway;
        case "DINEIN":
          return OrderStatusTimelineConstantsForDinein;
        default:
          return OrderStatusTimelineConstantsForDelivery;
      }
    },
  },
};
</script>

<style></style>
